<div class="popup-overlay modal-confirm ignore" >
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="content-popup">
              <div class="icon-popup"><img src="assets/img/unilever-icon.png"></div>
              
              <div class="des-hasimg">
                  <div class="img-popup">
                      <img src="assets/img/group-13.png"/>
                  </div>
                  <p class="text-popup"><strong>Có Banker trong giỏ hàng?</strong></p>
                  <div class="group-radio">
                      <div class="radio-item" *ngFor="let item of products" >
                          <label [for]="item.productId">
                              <input [id]="item.productId" type="checkbox" [(ngModel)]="item.checked">
                              <span class="checkmark"></span>
                              <p>{{item.productName}}</p>
                          </label>
                      </div>
                  </div>
                  <div class="group-btn-inline btn-center">
                      <button type="button" class="btn btn-primary btn-block" (click)="selectBanker()">Tiếp tục</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>